import urlJoin from 'url-join';

import { Locale } from '@/constants/locale';
import { KATALOG_URL, POSTAVSCHIKI_RYBY_URL } from '@/constants/routes';

type RewriteRoute = {
	source: string;
	destination: string;
	withPath?: boolean;
};

export const REWRITE_ROUTE_MAP: readonly RewriteRoute[] = [
	{
		source: '/avtomatizaciya-kommunikacii-s-klientami',
		destination: '/storage',
	},
	{
		source: 'avtomatizaciya-kommunikacii-s-klientami',
		destination: 'storage',
	},
	{ source: '/spravochniy-centr', destination: '/help-center' },
	{ source: 'spravochniy-centr', destination: 'help-center' },
];

const LOCALE_PREFIX_REGEXP = /^\/[a-z]{2}(?=\/|$)/;

export function buildPageUrl(pathname: string = '/', locale: Locale = Locale.Ru) {
	const localePath = locale === Locale.Ru ? '' : locale;
	const path = pathname === '/' ? '' : pathname.trim().replace(/(\/+)$/g, '');
	return `/${urlJoin(localePath, path)}`;
}

export function mapRewriteUrlToDestination(pageUrl: string) {
	const [urlWithoutHash, hash = ''] = pageUrl.split('#');
	const [fullPathname, search = ''] = urlWithoutHash.split('?');
	const localePrefix = fullPathname.match(LOCALE_PREFIX_REGEXP)?.[0] ?? '';
	const pathname = localePrefix ? fullPathname.slice(localePrefix.length) || '/' : fullPathname;

	const route = REWRITE_ROUTE_MAP.find(({ source, withPath }) => {
		return pathname === source || Boolean(withPath && pathname.startsWith(`${source}/`));
	});

	if (!route) return pageUrl;

	const restPath =
		route.withPath && pathname !== route.source ? pathname.slice(route.source.length) : '';
	const mappedPathname = `${localePrefix}${route.destination}${restPath}`;

	return `${mappedPathname}${search ? `?${search}` : ''}${hash ? `#${hash}` : ''}`;
}

export function isBuyFishPageUrl(pageUrl: string) {
	const pathname = pageUrl.split(/[?#]/)[0].replace(LOCALE_PREFIX_REGEXP, '') || '/';
	return pathname === KATALOG_URL || pathname.startsWith(`${KATALOG_URL}/`);
}

export const getCanonical = (url: string) => {
	return REWRITE_ROUTE_MAP.find((rpm) => rpm.source === url)?.destination ?? url;
};

export function getCanonicalPageUrl(pageUrl: string) {
	const [urlWithoutHash] = pageUrl.split('#');
	const [pathname, search = ''] = urlWithoutHash.split('?');
	const pathnameWithoutLocale = pathname.replace(LOCALE_PREFIX_REGEXP, '') || '/';
	const isProductPage =
		pathnameWithoutLocale === KATALOG_URL ||
		pathnameWithoutLocale.startsWith(`${POSTAVSCHIKI_RYBY_URL}/`);

	if (!isProductPage) {
		return pathname;
	}

	const productId = new URLSearchParams(search).get('productId');

	if (!productId) {
		return pathname;
	}

	return `${pathname}?${new URLSearchParams({ productId }).toString()}`;
}
